<template>
  <div :class="[ 'currency', modSize ]">
    <span class="currency__symbol">{{ symbol }}</span>
    <span class="currency_divider" v-if="measure">/</span>
    <span class="currency__measure" v-html="measure" v-if="measure"/>
  </div>
</template>

<script>

  export default {
    name: "Currency",
    props: {
      symbol: {
        type: String,
        default: '₽'
      },
      size: {
        type: String,
        default: 'md',
        validate(val) {
          return ['sm', 'md', 'lg'].includes(val);
        }
      },
      measure: {
        type: [String],
        default: ''
      }
    },
    computed: {
      modSize() {
        return `currency--size-${this.size}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .currency {
    display: inline-block;
    vertical-align: baseline;
    user-select: none;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    margin-left: 0.5em;
    color: inherit; // #555555

    /**
     * Elems
     */
    &__symbol,
    &__measure {
      display: inline-block;
      vertical-align: baseline;
      user-select: none;
    }

    &__measure sup {
      margin-left: -0.6em;
      left: 0.6em;
    }

    /**
     * Mods
     */
    &--size-sm {
      font-size: 12px;
      line-height: 22px;
    }

    &--size-md {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    &--size-lg {
      font-size: 1.5rem;
      line-height: 1rem;
    }

    &--size-xl {
      font-size: 24px;
      line-height: 32px;
    }
  }
</style>
